module.exports = __webpack_public_path__ + "static/media/ARF-0001_logo.eca6f4b9.png";